import {
  removeChildNodes,
  addClass,
  toggleClass,
  createSpan,
  append,
  removeClass,
  onClick,
  off,
  prepend,
  setText,
  remove,
} from '@acng/frontend-bounty';

import {ctxAmateur} from 'acng/amateurPool/context/amateur.js';
import {getIcon} from 'acng/core/service/icon';
import {
  LAYOUT_CLASS_ACTIVE,
  LAYOUT_CLASS_DISABLED,
  LAYOUT_CLASS_INACTIVE,
  LAYOUT_CLASS_WAIT,
} from 'acng/layout/config/css-classes';

import {checkPin} from '../service/cache.js';
import {compile} from '../service/template.js';
import {HTMLElement, con, def} from '@acng/frontend-bounty/dom/custom.js';
import {t} from 'acng/locale/config/translate.js';
import {togglePin} from '../service/http.js';
import {ctxPinsAvailable} from '../context/available.js';
import {Watch} from '@acng/frontend-relativity';
import {ElementSetup} from '@acng/frontend-stargazer';

const MODULE = 'pin/widget/button';
const VERBOSE = false;
DEBUG: if (VERBOSE) console.warn('Import verbose', MODULE);

const name = 'onsw-pin-button';

ElementSetup(name, () => {
  def(name, class extends HTMLElement {
    [con]() {
      controller(this);
    }
  });

  return compile;
});

const watchAmateur = Watch(name, ctxAmateur);
const watchPinsAvailable = Watch(name, ctxPinsAvailable);

/**
 * @param {HTMLElement} element
 */
function controller(element) {
  addClass(element, 'ons-item');

  watchAmateur(element, async (element, amateur) => {
    DEBUG: if (VERBOSE || element.hasAttribute('debug')) console.info(MODULE, {element, amateur});

    removeChildNodes(element);
    removeClass(element, LAYOUT_CLASS_ACTIVE, LAYOUT_CLASS_INACTIVE);
    if (!amateur) {
      return;
    }
    /**
     * @type {SVGSVGElement | undefined}
     */
    let activeIcon;
    const box = createSpan('box', 'pin-button');
    const label = createSpan('label');
    const enable = () => {
      onClick(box, click);
      removeClass(box, LAYOUT_CLASS_WAIT, LAYOUT_CLASS_DISABLED);
    };
    const click = async () => {
      off(box, 'click', click);
      addClass(box, LAYOUT_CLASS_WAIT);

      try {
        await togglePin(element, amateur);
      } finally {
        removeClass(box, LAYOUT_CLASS_WAIT);
        addClass(box, LAYOUT_CLASS_DISABLED);
        enable();
      }
    };

    watchPinsAvailable(element, async (element, pinsAreAvailable) => {
      DEBUG: if (VERBOSE || element.hasAttribute('debug')) console.info(MODULE, {element, pinsAreAvailable});
      const isPin = checkPin(amateur);
      toggleClass(box, LAYOUT_CLASS_ACTIVE, isPin);
      toggleClass(box, LAYOUT_CLASS_INACTIVE, !isPin);
      getIcon(isPin ? 'favoriteColor' : 'noFavorite').then((svg) => {
        if (activeIcon) {
          remove(activeIcon);
        }
        activeIcon = svg;
        prepend(box, svg);
      });
    });
    append(box, label);
    enable();
    append(element, box);
    setText(label, await t('pin.pin'));
  });
}
